<template>
    <div>

        <div class="player-filter">

            <div class="player-filter__switch">
                <ul>
                    <li>
                        <a @click.prevent="type = 'atp'"
                           :class="{ active: type == 'atp' }"
                           href="#">
                            <span>atp</span>
                        </a>
                    </li>
                    <li>
                        <a @click.prevent="type = 'wta'"
                           :class="{ active: type == 'wta' }"
                           href="#">
                            <span>wta</span>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="player-filter__type">
                <select v-model="selectedEvent"
                        id="s2eventSelector"
                        name="s2eventSelector">
                    <!--<option :value="event" v-for="event in possibleEvents">{{event}}</option>-->
                </select>
            </div>
            <div class="player-filter__type">
                <select v-model="selectedRound"
                        id="s2roundSelector"
                        name="s2roundSelector">
                    <!--<option :value="round" v-for="round in possibleRounds">{{round}}</option>-->
                </select>
            </div>


        </div>

        <div class="Results-matches">

            <score-card v-if="showMatch(match)"
                        v-for="match in matches"
                        :match="match"
                        :flagPath="flagPath"
                        :key="match.id"
                        mode="result"
                        :type="type"
                        :detail="detail"
                        :data-id="match.id">
            </score-card>

            <div class="na">
                <div class="na__info" v-html="ico_info"></div>

                <div class="na__title" style="margin-bottom: 0">
                    No results for this round
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import 'select2/dist/js/select2.full.js'

    import MatchCard from './MatchCard.vue'

    export default {
        props: ['pretype', 'flag', 'detail', 'tournament'],
        components: {
            'score-card': MatchCard
        },
        data() {
            return {
                selectedEvent   : '',
                selectedRound   : '',
                draws           : '',
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                matches         : [],
                possibleEvents  : [],
                possibleRounds  : [],
                type            : '',
                tournament_slug : this.tournament,
                ico_info        : window.ico_info,
            }
        },
        created() {
            this.type = this.pretype
            this.getFeed()
        },
        mounted() {
            let vm = this
            jQuery('#s2eventSelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedEvent = this.value
            })

            jQuery('#s2roundSelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedRound = this.value
            })
        },
        computed: {
            // possibleEvents() {
            //     return this.getPossibleEvents()
            // }
        },
        watch: {
            type() {
                this.getFeed()
            },
            selectedEvent(newEvent, oldEvent) {
                let currentEvent = this.getEventByDescription(newEvent)

                this.getPossibleRounds(currentEvent[0])

                this.reloadRound(this.selectedRound)

            },
            selectedRound(newRound, oldRound) {
                this.reloadRound(newRound)
            }
        },
        methods: {
            reloadRound(round) {
                let event = this.getEventByDescription(this.selectedEvent)
                let matches = this.getMatches(event[0], round)

                this.matches = matches
            },
            getFeed() {
                axios.get(`${window.feed_ip}/get/${this.type}/${this.tournament_slug}/draws`).then(response => {
                    this.draws = response.data

                    this.drawsSetup()
                }).catch(function (error) {
                    console.log(error);
                });
            },
            drawsSetup() {
                let events = []

                for (let event of this.draws) {
                    events.push(event.description)
                }

                let preselectedEvent = events[0]

                for (let event of this.draws) {
                    let rounds = event.rounds

                    let matches = []

                    for (let round of rounds) {
                        matches.push(...round.matches)
                    }

                    matches = matches.filter(match => match.detail != '')

                    if (matches.length > 0) {
                        preselectedEvent = event.description
                        break
                    }
                }

                this.possibleEvents = events
                this.selectedEvent = preselectedEvent

                let vm = this

                jQuery('#s2eventSelector').empty().select2({
                    width: '100%',
                    data: events.map(function (event) {
                        return {
                            id: event,
                            text: event
                        }
                    })
                }).val(preselectedEvent).trigger('change')
            },
            getEventByDescription(description) {
                return this.draws.filter(event => event.description == description)
            },
            getPossibleRounds(event) {
                let rounds = []

                if ( event == undefined) {
                    this.possibleRounds = []
                    this.selectedRound = ''

                    jQuery('#s2roundSelector').empty().select2({
                        width: '100%',
                    })
                    return
                }

                for (let round of event.rounds) {
                    rounds.push(round.id)
                }

                let preselectedRound = rounds[0]

                for (let round of event.rounds) {

                    let matches = []

                    matches.push(...round.matches)
                    matches = matches.filter(match => match.detail != '')

                    if (matches.length > 0) {
                        preselectedRound = round.id
                    }
                }

                this.possibleRounds = rounds
                this.selectedRound = preselectedRound

                jQuery('#s2roundSelector').empty().select2({
                    width: '100%',
                    data: rounds.map(function (round) {
                        return {
                            id: round,
                            text: round
                        }
                    })
                }).val(preselectedRound).trigger('change')

            },
            getMatches(event, roundId) {

                if ( event == undefined ) {
                    return []
                }

                let roundMatches = event.rounds.filter(round => round.id == roundId)


                return roundMatches[0].matches
            },
            showMatch(match) {
                if (!match.detail) {
                    return false
                }

                if (match.detail.state == 'F') {
                    return true
                }
            }
        }
    }
</script>
